export default {
  funnel_register_funnel_poe: ' 新角色剧情进度漏斗',

  funnel_channel_poe: "区服",
  funnel_channel_tips_poe: '玩家登录区服',
  funnel_channel_all_info_poe: '展示所有区服的去重用户数据',
  common_by_Channel_poe:'分区服',

  funnel_channel_language_poe: "赛季",
  funnel_language_expresion_poe: "玩家所处赛季",
  funnel_language_all_info_poe: '展示所有赛季的去重用户数据',
  common_by_Language_poe:'分赛季',

  funnel_app_version_poe: "赛季模式",
  funnel_app_version_tips_poe: "玩家的赛季模式",
  funnel_app_version_all_info_poe: '展示所有赛季模式的去重用户数据',
  funnel_by_app_version_poe:'分赛季模式',

  funnel_channel_network_poe: "用户类型",
  funnel_channel_network_tips_poe: "玩家的用户类型",
  funnel_channel_network_all_info_poe: "展示所有用户类型的去重用户数据",
  funnel_by_network_type_poe:'分用户类型',

  funnel_channel_memory_poe: "角色类别",
  funnel_channel_memory_tips_poe: "玩家的角色类别",
  funnel_channel_memory_all_info_poe: "展示所有角色类别的去重用户数据",
  funnel_by_memory_poe:'分角色类别',

  funnel_channel_step_poe: "剧情步骤",
  funnel_trends_by_step_poe: '剧情步骤趋势',
}